import { APIService, FetchListRequest } from "../../../services/api";
import { API } from "@/lib/api";

type HourAllocationType = "visit" | "period";
const ProjectService = new APIService<
  HourAllocationType[],
  HourAllocationType[]
>(API.Projects);

export const HourAllocationTypeService = {
  getList: (fetchParams?: FetchListRequest<HourAllocationType[]>) => {
    return ProjectService.getList<HourAllocationType[]>(
      fetchParams ?? {},
      "/schedules/hour-allocation-types",
    );
  },
};
